import {AppState} from "redux/reducers"

export const getFirebaseState = (state:AppState) => state.firebase

export const getUserProfile = (state:AppState) => getFirebaseState(state).profile
export const getAuth = (state:AppState) => getFirebaseState(state).auth
export const getAuthError = (state:AppState) => getFirebaseState(state).authError
export const getAuthUid = (state:AppState) => getAuth(state).uid
